import script from "./HrItemSection.vue?vue&type=script&setup=true&lang=js"
export * from "./HrItemSection.vue?vue&type=script&setup=true&lang=js"

import "./HrItemSection.vue?vue&type=style&index=0&id=2ba153c7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ba153c7"]])

export default __exports__
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QItemSection,QItem});
